import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import CustomeButton from "../../../components/Button/index";
import AddressFileds from "./AddressFileds";
import AddressType from "./AddressType";
import { fetchCities, fetchStates } from "./addressesSlice";
import Banner from "~/components/Banner";
import banner from "../../../assets/images/banner.png";
function validNumber(x) {
  const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
  return out;
}

const AddressForm = (props) => {
  const { regAddData, setRegAddData, enableEntityPlus = false } = props;
  const dispatch = useDispatch();

  function validateAll(dataArray) {
    for (const item of dataArray) {
      if (
        !item.country ||
        !item.country.name ||
        !item.country.code ||
        !item.type?.trim() ||
        !item.address_line_1?.trim() ||
        !item.postalcode?.trim() ||
        !validNumber(item.postalcode)
      ) {
        return false;
      }
    }
    return true;
  }

  const handleAddRegister = () => {
    if (regAddData.length >= 3) return;
    if (regAddData.length == 2 && regAddData.some((item) => !item.type)) return;

    const allTypes = ["Registered", "Physical", "Trading"];

    let type = "";
    if (regAddData.length === 2) {
      const usedTypes = regAddData.map((item) => item.type);
      const missingType = allTypes.find((t) => !usedTypes.includes(t));
      type = missingType || "";
    }

    const newAddress = {
      id: Math.floor(Math.random() * 100),
      type: type,
      country: "",
      address_line_1: "",
      address_line_2: "",
      state: "",
      city: "",
      postalcode: "",
      stateOptions: [],
      cityOptions: [],
    };

    setRegAddData((prev) => [...prev, newAddress]);
  };
  const handleToggle = (id, type) => {
    if (regAddData.length === 3) return;
    setRegAddData((prev) =>
      prev.map((item) => (item?.id === id ? { ...item, type } : item)),
    );
  };

  const handleOnchange = async (e, id) => {
    const { name, value } = e.target;

    setRegAddData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [name]: value } : item)),
    );
    if (name === "country") {
      const countryCode = value.code;
      const stateRes = await dispatch(fetchStates(countryCode)).unwrap();
      const stateOptions = stateRes.map((state) => ({
        name: state.label,
        code: state.value,
      }));
      setRegAddData((prev) =>
        prev.map((item) =>
          item.id === id
            ? {
                ...item,
                state: null,
                city: null,
                stateOptions,
                cityOptions: [],
                country: value,
              }
            : item,
        ),
      );
    }
    if (name === "state") {
      const item = regAddData.find((item) => item.id === id);
      const countryCode = item?.country?.code;
      const stateCode = value.code;

      if (countryCode && stateCode) {
        const cityRes = await dispatch(
          fetchCities([countryCode, stateCode]),
        ).unwrap();
        const cityOptions = cityRes.map((city) => ({
          name: city.label,
          code: city.value,
        }));

        setRegAddData((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  state: value,
                  city: null,
                  cityOptions,
                }
              : item,
          ),
        );
      }
      if (name === "city") {
        setRegAddData((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, city: value } : item,
          ),
        );
      }
    }
  };
  const removeAddress = (id) => {
    setRegAddData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="formgrid grid ">
      <div className="col-12 ">
        <p className="sub-address-heading">Registered Address</p>
      </div>
      <AddressFileds
        isEdit={true}
        handleOnchange={handleOnchange}
        data={regAddData.find((x) => x?.type === "Registered")}
      />
      <div className="col-12 mb-3">
        <hr className="my-2" style={{ borderColor: "#DFE7EF" }} />
      </div>

      {!enableEntityPlus && (
        <>
          {regAddData
            .filter((item) => item?.type !== "Registered")
            .map((item, i) => {
              return (
                <>
                  <div className="col-6 text-left ">
                    <p className="sub-address-heading">New Address</p>
                  </div>

                  <div
                    className="col-6 "
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      textAlign: "right",
                      alignItems: "flex-end",
                    }}
                  >
                    <CustomeButton
                      label="Remove Address"
                      variant="outlined"
                      className="mr-2"
                      icon="pi pi-trash"
                      iconPos="right"
                      onClick={() => removeAddress(item.id)}
                    />
                  </div>
                  <div className="col-12 text-left ">
                    <p className="address-sub-heading">
                      {" "}
                      Select the address type you want to register
                    </p>
                  </div>
                  <AddressType
                    key={i}
                    data={item}
                    disableTrade={
                      item.type === "Physical" || regAddData.length === 3
                    }
                    disablePhysical={
                      item.type === "Trading" || regAddData.length === 3
                    }
                    handleToggle={handleToggle}
                  />
                  {item.type && (
                    <AddressFileds
                      isEdit={true}
                      handleOnchange={handleOnchange}
                      data={regAddData.find((x) => x?.type === item.type)}
                    />
                  )}
                </>
              );
            })}
          {regAddData.length < 3 && (
            <div className="col-12 text-left">
              <CustomeButton
                label="Add New Address"
                variant="outlined"
                className={`"mr-2 ${regAddData.some((item) => !item.type) && "disable-btn"}`}
                disabled={regAddData.some((item) => !item.type)}
                icon="pi pi-plus"
                iconPos="right"
                onClick={() => handleAddRegister()}
              />
            </div>
          )}
        </>
      )}
      {enableEntityPlus && (
        <div className="mx-2 w-full">
          <Banner
            image={banner}
            title="Want to add more addresses?"
            description="Unlock this and other features with an Entities Plus subscription."
            onClick={() => {}}
          />
        </div>
      )}
    </div>
  );
};

AddressForm.propTypes = {
  setRegAddData: PropTypes.func,
  regAddData: PropTypes.object,
  enableEntityPlus: PropTypes.boolean,
};

export default AddressForm;
